import { useSelector } from "react-redux";
import { useMemo } from "react";
import {
  SORTING_TIME_ASC,
  SORTING_TIME_DESC,
  SORTING_REGISTRATION_ASC,
  SORTING_REGISTRATION_DESC,
  SORTING_PRIZE_ASC,
  SORTING_PRIZE_DESC,
  TOURNEY_STATUS_LIVE,
} from "./../../../Poker/data/Constants";

export default function useMasterTourneyDefinitionsIds(tourneyTab) {
  const data = useSelector((state) => state?.lobby?.masterTourneysData);
  const tourneyShortsAndFilters = useSelector(
    (state) => state?.lobby?.tourneyFilterSortConfig
  );

  return useMemo(() => {
    if (!data || typeof data.entries !== "function") return [];

    const isAll = (val) => !val || val === "All" || val === "all";

    const createFilters = () => {
      const filters = {};
      if (
        Array.isArray(tourneyShortsAndFilters?.gameType) &&
        tourneyShortsAndFilters.gameType.length > 0
      ) {
        filters.gameType = (val) =>
          tourneyShortsAndFilters.gameType.includes(val);
      }
      if (
        Array.isArray(tourneyShortsAndFilters?.tourneyStatus) &&
        tourneyShortsAndFilters.tourneyStatus.length > 0
      ) {
        filters.tourneyStatus = (_, tourney) =>{
let val = tourney?.tourneyStatus;
if(tourneyShortsAndFilters.tourneyStatus.includes("LATE_REGISTRATION") && tourney?.tourneyStatus === TOURNEY_STATUS_LIVE &&
tourney?.lateRegistrationAllowed &&
tourney?.lateRegistrationStatus !== "FINISHED" &&
        !tourney?.lateRegEnded) {
  return true;
}
          return tourneyShortsAndFilters.tourneyStatus.includes(val);}
      }
      if (
        Array.isArray(tourneyShortsAndFilters?.buyIn) &&
        tourneyShortsAndFilters.buyIn.length > 0
      ) {
        filters.buyIn = (_, tourney) => {
          let buyInValue = 0;
          if (tourney?.bountyTourney) {
            buyInValue =
              tourney?.buyIn + tourney?.tourneyRake + tourney?.bountyBuyIn;
          } else {
            buyInValue = tourney?.buyIn + tourney?.tourneyRake;
          }
          for (const filter of tourneyShortsAndFilters.buyIn) {
            if (filter.startsWith("<=")) {
              const max = parseFloat(filter.slice(2));
              if (buyInValue <= max) return true;
            } else if (filter.startsWith(">=")) {
              const min = parseFloat(filter.slice(2));
              if (buyInValue >= min) return true;
            } else if (filter.startsWith(">")) {
              const min = parseFloat(filter.slice(1));
              if (buyInValue > min) return true;
            } else if (filter.startsWith("<")) {
              const max = parseFloat(filter.slice(1));
              if (buyInValue < max) return true;
            } else if (filter.includes("-")) {
              const [min, max] = filter.split("-").map(Number);
              if (buyInValue >= min && buyInValue <= max) return true;
            }
          }
          return false;
        };
      }
      if (
        Array.isArray(tourneyShortsAndFilters?.format) &&
        tourneyShortsAndFilters.format.length > 0
      ) {
        filters.format = (_, tourney) => {
          return (
            tourneyShortsAndFilters.format.includes(tourney?.reEntryType) ||
            (tourneyShortsAndFilters.format.includes("DealMaking") &&
              tourney?.tourneyFeatures?.dealMaking) ||
            (tourneyShortsAndFilters.format.includes("MysteryBounty") &&
              tourney?.tourneyFeatures?.bountyTourney) ||
            (tourneyShortsAndFilters.format.includes("Knockout") &&
              !tourney?.tourneyCompleteViaAtInTheMoney)
          );
        };
      }
      return filters;
    };

    const applyFilters = (data, filters) => {
      const result = [];
      for (const [tourneyId, tourney] of data.entries()) {
        const typeMatch =
          isAll(tourneyTab) || tourney.tourneyTabs.includes(tourneyTab);
        const predicates = Object.entries(filters);
        const allMatch = predicates.every(([key, fn]) =>
          fn(tourney[key], tourney)
        );
        if (typeMatch && allMatch) {
          result.push({ id: tourneyId, ...tourney });
        }
      }
      return result;
    };

    const getSortFunction = (sortBy) => {
      switch (sortBy) {
        case SORTING_TIME_ASC:
          return (a, b) => a.tourneyStartTime - b.tourneyStartTime;
        case SORTING_TIME_DESC:
          return (a, b) => b.tourneyStartTime - a.tourneyStartTime;
        case SORTING_REGISTRATION_ASC:
          return (a, b) =>
            a.buyIn +
            (a.tourneyRake || 0) +
            (a.bountyBuyIn || 0) -
            (b.buyIn + (b.tourneyRake || 0) + (b.bountyBuyIn || 0));
        case SORTING_REGISTRATION_DESC:
          return (a, b) =>
            b.buyIn +
            (b.tourneyRake || 0) +
            (b.bountyBuyIn || 0) -
            (a.buyIn + (a.tourneyRake || 0) + (a.bountyBuyIn || 0));
        case SORTING_PRIZE_ASC:
          return (a, b) => a.prizePool - b.prizePool;
        case SORTING_PRIZE_DESC:
          return (a, b) => b.prizePool - a.prizePool;
        default:
          return null;
      }
    };

    const filtersObj = createFilters();
    let filteredTourneys = applyFilters(data, filtersObj);
    // Sorting logic
    const sortBy = tourneyShortsAndFilters?.sortBy;
    const sortFn = getSortFunction(sortBy);
    if (sortFn) {
      filteredTourneys.sort(sortFn);
    }
    return filteredTourneys.map((t) => t.id);
  }, [data, tourneyShortsAndFilters, tourneyTab]);
}
